module.exports = __webpack_public_path__ + "img/side-app.9ba18ff7.png";